// ** api slice import
import { slices } from '../../app/slice';

// ** api routes for admin quiz management
const routes = {
  UPDATE_SECTION_ANSWER_BY_ADMIN:
    '/quiz/response/:sessionId/answer/:sectionNumber/admin-update',
  GET_QUIZ_SECTION: '/quiz/response/:sessionId/section/:sectionNumber',
};

// ** slice for admin quiz management
const adminQuizApiSlice = slices.injectEndpoints({
  endpoints: builder => ({
    updateSectionAnswerByAdmin: builder.mutation({
      query: ({ sessionId, sectionNumber, data }) => ({
        url: routes.UPDATE_SECTION_ANSWER_BY_ADMIN.replace(
          ':sessionId',
          sessionId
        ).replace(':sectionNumber', sectionNumber),
        method: 'PUT',
        body: data,
      }),
    }),
    getQuizSection: builder.query({
      query: ({ sessionId, sectionNumber }) => ({
        url: routes.GET_QUIZ_SECTION.replace(':sessionId', sessionId).replace(
          ':sectionNumber',
          sectionNumber
        ),
        method: 'GET',
      }),
    }),
  }),
});

export const { useUpdateSectionAnswerByAdminMutation, useGetQuizSectionQuery } =
  adminQuizApiSlice;
